// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmText[data-v-3706f4d0]{font-size:15px;font-weight:700}", ""]);
// Exports
module.exports = exports;
